import React from 'react';
import { DataGrid } from '@mui/x-data-grid';
import { LinearProgress, Link } from '@mui/material';
import { useSelector } from 'react-redux';
import { selectedUserIdSelector } from '../../../../selectors/userSelectors';
import { useGetTasksQuery } from '../../../../api/tasksApi';
import { convertEnumToTitleCase } from '../../../../utils/stringUtils';

const TasksSection = () => {
  const selectedUserId = useSelector(selectedUserIdSelector);
  const { data: tasks = [], error, isLoading } = useGetTasksQuery(selectedUserId);

  if (error) {
    return <div>{error.message}</div>;
  }

  const columns = [
    {
      field: 'taxYear',
      headerName: 'Tax Year',
      minWidth: 50
    },
    {
      field: 'type',
      headerName: 'Type',
      minWidth: 120,
      valueGetter: (value) => convertEnumToTitleCase(value)
    },
    {
      field: 'stage',
      headerName: 'Stage',
      minWidth: 170
    },
    {
      field: 'hasNotes',
      headerName: 'Has Notes',
      minWidth: 70,
      valueGetter: (value) => (value ? 'Yes' : 'No')
    },
    {
      field: 'link',
      headerName: 'Link',
      minWidth: 70,
      renderCell: (params) => {
        return (
          <Link href={params.value} target='_blank' rel='noopener noreferrer'>
            Link
          </Link>
        );
      }
    }
  ];

  return (
    <DataGrid
      slotProps={{ root: { 'data-testid': 'tasks-section' } }}
      rows={tasks}
      slots={{
        loadingOverlay: LinearProgress
      }}
      columns={columns}
      loading={isLoading}
      autosizeOnMount
      autoPageSize
      initialState={{
        sorting: {
          sortModel: [{ field: 'taxYear', sort: 'desc' }]
        }
      }}
    />
  );
};

export default TasksSection;
